import type { SalesMovePriority } from "@sales-ops-amplify/shared";
import { SALES_MOVE_PRIORITY_LABELS } from "@sales-ops-amplify/shared";

export function formatMoney(amount: number, currency = "USD"): string {
  if (amount >= 1_000_000) return `$${(amount / 1_000_000).toFixed(1)}M`;
  if (amount >= 1_000) return `$${(amount / 1_000).toFixed(0)}K`;
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `$${Math.round(amount).toLocaleString()}`;
  }
}

export function formatDue(iso?: string): string {
  if (!iso) return "";
  const due = new Date(iso);
  if (Number.isNaN(due.getTime())) return "";
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const dueDay = new Date(due.getFullYear(), due.getMonth(), due.getDate());
  const diff = (dueDay.getTime() - start.getTime()) / 86_400_000;
  if (diff < 0) return "Overdue";
  if (diff === 0) return "Due today";
  if (diff === 1) return "Due tomorrow";
  return `Due ${due.toLocaleDateString()}`;
}

export function priorityLabel(p: SalesMovePriority): string {
  return SALES_MOVE_PRIORITY_LABELS[p];
}
